import { z } from 'zod';
import { idSchema } from '../primitives/branded.js';
import { timestampSchema } from '../primitives/timestamp.js';
/**
 * Mandant und Benutzer.
 *
 * Ein **Mandant** trennt Datenbestände: Positionen, Zeichnungen und der Verlauf
 * gehören genau einem. Kursdaten und Instrumente dagegen sind **gemeinsam** —
 * sie sind nicht mandantenspezifisch, und sie je Mandant erneut abzurufen würde
 * nur das Budget des Anbieters belasten.
 *
 * **Ein Mandant je Konto.** Depotdaten sind persönlich: Positionen, Einstandskurse
 * und Stop-Loss-Entscheidungen gehen Kolleginnen und Kollegen nichts an, auch wenn
 * alle zur selben Organisation gehören.
 *
 * Die Organisation steuert, **wer sich anmelden darf**, nicht wer welche Daten
 * sieht. Ein gemeinsamer Bestand für eine Organisation ließe sich später ergänzen,
 * ohne die vorhandenen Mandanten anzurühren.
 */
export const tenantSchema = z.object({
    id: idSchema,
    /**
     * Fachlicher Schlüssel des Mandanten.
     *
     * `user:<Google-Subject>` — an das Konto gebunden, nicht an die E-Mail-Adresse.
     * Eindeutig, damit eine erneute Anmeldung denselben Mandanten findet.
     */
    slug: z.string().min(1).max(190),
    name: z.string().min(1).max(160),
    createdAt: timestampSchema,
});
export const userSchema = z.object({
    id: idSchema,
    tenantId: idSchema,
    /**
     * Googles unveränderlicher Bezeichner für das Konto.
     *
     * Nicht die E-Mail-Adresse: Die kann sich ändern, ohne dass es eine andere Person
     * wird — und wer sie als Schlüssel nutzt, verliert bei einer Umbenennung den
     * Zugang zu den eigenen Daten.
     */
    subject: z.string().min(1).max(190),
    email: z.email(),
    name: z.string().max(160).nullable(),
    pictureUrl: z.url().max(500).nullable(),
    lastLoginAt: timestampSchema.nullable(),
    createdAt: timestampSchema,
});
/** Was die Oberfläche über die angemeldete Person wissen muss. */
export const sessionUserSchema = z.object({
    email: z.email(),
    name: z.string().nullable(),
    pictureUrl: z.string().nullable(),
    tenantName: z.string(),
    /** True, wenn die Anmeldung lokal umgangen wird. */
    isDevelopmentSession: z.boolean(),
});
//# sourceMappingURL=tenant.js.map